import React, { ReactElement } from 'react';
import { SvgIcon } from '../../components';
import type { SvgIconProps } from '../../components/SvgIcon';

function PartiallyCloudyIcon(props: SvgIconProps): ReactElement {
  return (
    <SvgIcon {...props} viewBox="0 0 25.65 18.209">
      <g transform="translate(-253 -168)">
        <g transform="translate(2509.514 227)">
          <g
            transform="translate(-2244.323 -53.307)"
            fill="none"
            stroke="currentColor"
            strokeWidth="1"
          >
            <circle cx="3.911" cy="3.911" r="3.911" stroke="none" />
            <circle cx="3.911" cy="3.911" r="3.411" fill="none" />
          </g>
          <line
            id="Line_161"
            data-name="Line 161"
            y2="4.172"
            transform="translate(-2236.762 -46.006) rotate(-45)"
            fill="none"
            stroke="currentColor"
            strokeLinecap="round"
            strokeWidth="1"
          />
          <line
            id="Line_165"
            data-name="Line 165"
            y1="4.172"
            transform="translate(-2231.364 -49.396) rotate(90)"
            fill="none"
            stroke="currentColor"
            strokeLinecap="round"
            strokeWidth="1"
          />
          <line
            id="Line_169"
            data-name="Line 169"
            y1="4.172"
            transform="translate(-2240.412 -58.5)"
            fill="none"
            stroke="currentColor"
            strokeLinecap="round"
            strokeWidth="1"
          />
          <line
            id="Line_171"
            data-name="Line 171"
            y1="4.172"
            transform="translate(-2233.812 -55.758) rotate(45)"
            fill="none"
            stroke="currentColor"
            strokeLinecap="round"
            strokeWidth="1"
          />
          <line
            id="Line_172"
            data-name="Line 172"
            y2="4.172"
            transform="translate(-2244.063 -52.808) rotate(135)"
            fill="none"
            stroke="currentColor"
            strokeLinecap="round"
            strokeWidth="1"
          />
        </g>
        <g transform="translate(2518 188)">
          <g transform="translate(-2265 -12.894)" fill="none">
            <path
              d="M 16.37639999389648 10.6023998260498 L 3.05280065536499 10.6023998260498 C 1.645180583000183 10.6023998260498 0.500000536441803 9.457220077514648 0.500000536441803 8.049599647521973 C 0.500000536441803 7.014569759368896 1.117320537567139 6.088709831237793 2.072710514068604 5.690849781036377 L 2.375120639801025 5.564909934997559 L 2.380420446395874 5.237370014190674 C 2.402910470962524 3.849449872970581 3.724780559539795 2.720299959182739 5.32710075378418 2.720299959182739 C 5.632980346679688 2.720299959182739 5.934900760650635 2.760859966278076 6.224460601806641 2.840849876403809 L 6.712710380554199 2.975719928741455 L 6.841240406036377 2.485769987106323 C 7.143070697784424 1.335139870643616 8.35149097442627 0.4999999105930328 9.714600563049316 0.4999999105930328 C 11.07746028900146 0.4999999105930328 12.28630065917969 1.335259914398193 12.58894062042236 2.486069917678833 L 12.71778011322021 2.975989818572998 L 13.20598030090332 2.840749979019165 C 13.49452018737793 2.760829925537109 13.7960205078125 2.720299959182739 14.10210037231445 2.720299959182739 C 15.70442008972168 2.720299959182739 17.02629089355469 3.849449872970581 17.04877090454102 5.237370014190674 L 17.0540714263916 5.564909934997559 L 17.35647964477539 5.690849781036377 C 18.31187057495117 6.088699817657471 18.92920112609863 7.014569759368896 18.92920112609863 8.049599647521973 C 18.92920112609863 9.457220077514648 17.78402137756348 10.6023998260498 16.37639999389648 10.6023998260498 Z"
              stroke="none"
            />
            <path
              d="M 16.37639999389648 10.1023998260498 C 17.50831985473633 10.1023998260498 18.42920112609863 9.181519508361816 18.42920112609863 8.049599647521973 C 18.42920112609863 7.217109680175781 17.93268013000488 6.472419738769531 17.16427040100098 6.152420043945312 L 16.55944061279297 5.90054988861084 L 16.54883003234863 5.245460033416748 C 16.5307502746582 4.128779888153076 15.43315029144287 3.220299959182739 14.10210037231445 3.220299959182739 C 13.84112071990967 3.220299959182739 13.5845308303833 3.254719972610474 13.3394603729248 3.322609901428223 L 12.36307048797607 3.593079805374146 L 12.10538101196289 2.613229990005493 C 11.8595609664917 1.678459882736206 10.85409069061279 0.9999999403953552 9.714600563049316 0.9999999403953552 C 8.575010299682617 0.9999999403953552 7.569990634918213 1.678209900856018 7.324870586395264 2.612629890441895 L 7.067830562591553 3.592549800872803 L 6.091330528259277 3.322799921035767 C 5.845120429992676 3.25478982925415 5.588000774383545 3.220299959182739 5.32710075378418 3.220299959182739 C 3.996050596237183 3.220299959182739 2.898450613021851 4.128789901733398 2.88036060333252 5.24547004699707 L 2.869750499725342 5.90054988861084 L 2.264930486679077 6.152420043945312 C 1.49651050567627 6.472419738769531 1.000000596046448 7.217109680175781 1.000000596046448 8.049599647521973 C 1.000000596046448 9.181519508361816 1.920880556106567 10.1023998260498 3.05280065536499 10.1023998260498 L 16.37639999389648 10.1023998260498 M 16.37639999389648 11.1023998260498 L 3.05280065536499 11.1023998260498 C 1.367100596427917 11.1023998260498 5.630492978525581e-07 9.735300064086914 5.630492978525581e-07 8.049599647521973 C 5.630492978525581e-07 6.778579711914062 0.7764405608177185 5.689039707183838 1.88049054145813 5.229269981384277 C 1.907480597496033 3.563279867172241 3.440450668334961 2.220299959182739 5.32710075378418 2.220299959182739 C 5.686200618743896 2.220299959182739 6.031800746917725 2.268899917602539 6.357600688934326 2.358899831771851 C 6.71220064163208 1.007099866867065 8.0802001953125 -8.697509912281021e-08 9.714600563049316 -8.697509912281021e-08 C 11.34900093078613 -8.697509912281021e-08 12.71700096130371 1.007099866867065 13.07250022888184 2.358899831771851 C 13.39740085601807 2.268899917602539 13.74300098419189 2.220299959182739 14.10210037231445 2.220299959182739 C 15.98875045776367 2.220299959182739 17.52172088623047 3.563279867172241 17.5487003326416 5.229269981384277 C 18.65276145935059 5.689039707183838 19.42920112609863 6.778579711914062 19.42920112609863 8.049599647521973 C 19.42920112609863 9.735300064086914 18.06210136413574 11.1023998260498 16.37639999389648 11.1023998260498 Z"
              stroke="none"
              fill="currentColor"
            />
          </g>
        </g>
      </g>
    </SvgIcon>
  );
}

export default PartiallyCloudyIcon;
